module.exports = __webpack_public_path__ + "static/media/icons-tooltip.52b4e76c.svg";